'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

require('../pageHeader/pageHeader');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// The generic page header component

var WinresOmalomaPageHeader = function () {
    function WinresOmalomaPageHeader($scope, omalomaService, $filter, $rootScope) {
        var _this = this;

        _classCallCheck(this, WinresOmalomaPageHeader);

        this.$scope = $scope;
        this.omalomaService = omalomaService;
        this.$filter = $filter;
        this.$rootScope = $rootScope;

        $scope.$watch(function () {
            return _this.bookingNumber;
        }, function () {
            return _this.update();
        });
        $scope.$watch(function () {
            return _this.defaultHeaderImage;
        }, function () {
            return _this.$scope.image = _this.defaultHeaderImage;
        }); // Update header image.
    }

    _createClass(WinresOmalomaPageHeader, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.$rootScope.$on('logout', function () {
                return _this2.reset();
            });
            this.update();
        }
    }, {
        key: 'reset',
        value: function reset() {
            // this.$scope.title = null;
            // this.$scope.subtitle = null;
            // this.$scope.image = null;
            this.$scope.title = ' '; // space prevents the html elements from collapsing when no data
            this.$scope.subtitle = ' ';
            //this.$scope.image = 'https://omalomat.fi/wp-content/uploads/2018/04/bg-5-1600x600.jpg';
            this.$scope.image = this.defaultHeaderImage;
        }
    }, {
        key: 'update',
        value: function update() {
            var _this3 = this;

            if (!this.bookingNumber) {
                this.reset();
                return;
            }
            console.log("[WOPH] Haetaan....");
            this.$scope.subtitle = this.$filter('i18next')('omaloma.page_header.loading_reservation');
            this.omalomaService.getCustomerInfo().then(function (response) {
                var tempString = document.querySelectorAll('.tervetuloa-title')[0].innerHTML;
                if (tempString.indexOf(response.FirstName) === -1) {
                    tempString = tempString.replace(/!/g, "\,");
                    document.querySelectorAll('.tervetuloa-title')[0].innerHTML = tempString + ' ' + response.FirstName + "!";
                }
            });
            this.omalomaService.getHeaderInfo(this.bookingNumber).then(function (info) {

                // info.Headline is hidden for now because it did not contain suitable data for header
                // instead we hard code the title for now
                //this.$scope.title = info.Headline || "Oma lomasi";
                _this3.$scope.title = _this3.$filter('i18next')('omaloma.page_header.your_reservation');

                //info.BeginDate = moment(info.BeginDate).utcOffset('+0300').format('d.M.YYYY ');
                //info.EndDate = moment(info.EndDate).utcOffset('+0300').format('d.M.YYYY');

                // info.BeginDate = this.$filter('date')(info.BeginDate, "d.M.yyyy");
                // info.EndDate  = this.$filter('date')(info.EndDate, "d.M.yyyy");

                var beginDate = _this3.$filter('date')(info.BeginDate, "d.M.yyyy");
                var endDate = _this3.$filter('date')(info.EndDate, "d.M.yyyy");

                _this3.$scope.subtitle = info.Subtitle + ' ' + beginDate + '\xa0-\xa0' + endDate; // Non-breakable space is char 0xa0 (160 dec)
                _this3.$scope.image = info.Image || "https://omalomat.fi/wp-content/uploads/2018/04/bg-5-1600x600.jpg";
            }).catch(function (error) {
                console.error('[WOPH] Failed to get header info', _this3.bookingNumber, ':', error);
                _this3.reset();

                _this3.$scope.title = "";
                _this3.$scope.subtitle = _this3.$filter('i18next')('omaloma.page_header.header_info_error');
            });
        }
    }]);

    return WinresOmalomaPageHeader;
}();

WinresOmalomaPageHeader.$inject = ['$scope', 'omalomaService', '$filter', '$rootScope'];

_module3.default.component('winresOmalomaPageHeader', {
    template: require('./winresOmalomaPageHeader.html'),
    controller: WinresOmalomaPageHeader,
    bindings: {
        bookingNumber: '<',
        defaultHeaderImage: '<'
    },
    require: {}
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaPageHeader/winresOmalomaPageHeader.js
// module id = 345
// module chunks = 2